export default __webpack_public_path__ + "static/media/key_features.501c2788.mp4";